<script setup lang="ts">
const $i18n = useI18n()

if (import.meta.client) {
    const fromLocale = $i18n.locale.value
    let toLocale = 'en-us'
    switch (fromLocale) {
    case 'es':
    case 'fr':
    case 'de':
    case 'it':
        toLocale = `${fromLocale}-${fromLocale}`
        break
    case 'es-XL':
        toLocale = 'es-es'
        break
    // TODO: case for pt-br (support site doesn't support this lag yet)
    }
    window.location.href = `//support.jackboxgames.com/hc/${toLocale}`
}
</script>
